import {
  LISTING_DATA_SOURCE_SMART_APARTMENT,
} from 'common/listingConstants';

import {
  TOUR_TYPE_RENTER_REQUESTED,
} from 'common/tourConstants';

import {
  SR_API_ACTION_REQUEST_TOUR_SHOWING,
} from 'api/actionTypes';

import analytics from 'client/analytics';
import { makeListingApplicationContext } from 'client/analytics/makeApplicationContext';

import {
  ANALYTICS_EVENT_AGENT_TOUR_REQUESTED,
  ANALYTICS_EVENT_SHOWING_ADDED_TO_AGENT_TOUR,
  ANALYTICS_EVENT_AGENT_FIRST_TOUR_REQUESTED,
} from 'client/analytics/eventList';

import getListingByIdAction from 'client/actions/Listing/getById';
import askForMobileAppReview from 'client/actions/MobileApp/askForReview';
import getToursList from './getList';

export default async function requestShowing({ state, apiClient }, {
  requestedFrom,
  listingId,
  createNewTour,
  startDate,
  availableTimes,
  addToTourId,
}) {
  const listing = await getListingByIdAction({ state, apiClient }, listingId);

  const listingRentPrice = listing.dataSource === LISTING_DATA_SOURCE_SMART_APARTMENT
    ? listing.minUnitPrice
    : listing.price;

  const requestTourShowingApiPayload = {
    requestedFrom,
    listingId,
    addToTourId,
    createNewTour,
    startDate,
    availableTimes,
    type: TOUR_TYPE_RENTER_REQUESTED,
  };

  await apiClient.postWithState({
    action: SR_API_ACTION_REQUEST_TOUR_SHOWING,
    queryId: String(listingId),
    state: state,
    payload: requestTourShowingApiPayload,
    async onSuccess(tourId) {
      state.set(['showTourAddedToCartTooltip'], true);
      const tours = state.get('tours');

      const analyticsEventData = {
        ...makeListingApplicationContext(listing),
        ...requestTourShowingApiPayload,
        // WARN(@d-oliveros): This is needed to make Facebook ads retargeting work.
        value: listingRentPrice.toFixed(2),
      };

      if (tours && tours.find(({ id }) => tourId === id)) {
        analytics.track(ANALYTICS_EVENT_SHOWING_ADDED_TO_AGENT_TOUR, analyticsEventData);
      }
      else {
        analytics.track(ANALYTICS_EVENT_AGENT_TOUR_REQUESTED, analyticsEventData);
      }

      if (tours && tours.length === 0) {
        analytics.track(ANALYTICS_EVENT_AGENT_FIRST_TOUR_REQUESTED, {
          listingId,
        });
      }

      getToursList({ state, apiClient }, { reloadTours: true, queryId: listingId });
      askForMobileAppReview({ state });
    },
  });
}
